import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { RxStomp } from '@stomp/rx-stomp';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebsocketrxService implements OnDestroy {

  private rxStomp?: RxStomp;
  private isBrowser: boolean;


  private messagesSubject = new BehaviorSubject<any | null>(null);
  public messages$: Observable<string | null> = this.messagesSubject.asObservable();

  private subscriptions = new Map<string, Subscription>();

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.rxStomp = new RxStomp();
      this.rxStomp.configure({
        brokerURL: 'wss://ci-core-api.cochabamba.bo/ws'
      });
      this.rxStomp.activate();
    }
  }

  subscribeToTopic(topic: string) {
    if (this.rxStomp && this.isBrowser) {

      this.unsubscribeFromTopic(topic);

      const newSubscription = this.rxStomp
        .watch({ destination: topic })
        .subscribe((message) => {
          this.messagesSubject.next(message);
        });

      this.subscriptions.set(topic, newSubscription);
    }
  }

  unsubscribeFromTopic(topic: string) {
    if (this.subscriptions.has(topic)) {
      this.subscriptions.get(topic)?.unsubscribe();
      this.subscriptions.delete(topic);
    }
  }

  sendMessage(destination: string, body: string) {
    if (this.rxStomp && this.isBrowser) {
      this.rxStomp.publish({ destination, body });
    }
  }

  disconnect() {
    this.subscriptions.forEach((subscription, topic) => {
      subscription.unsubscribe();
    });
    this.subscriptions.clear();

    if (this.rxStomp && this.isBrowser) {
      this.rxStomp.deactivate();
    }
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
